import { z } from 'zod/v4'
import { useMesaParameterStore } from '@/src/services/Statsig/useMesaParameterStore'

export const CardPaymentsAgreementStoreSchema = z.object(
  {
    url: z.url(),
  },
  { message: 'CardPaymentsAgreement store is not valid' },
)

export const CardPaymentsStoreSchema = z.object(
  {
    agreement: CardPaymentsAgreementStoreSchema,
  },
  { message: 'CardPayments store is not valid' },
)

export type CardPaymentsStore = z.infer<typeof CardPaymentsStoreSchema>

export function useCardPaymentsParameterStore() {
  return useMesaParameterStore('card_payments')
}
